import { createElement, lazy } from 'react'

import { DEFAULT_ROUTES_CONFIG } from './route-configs.constants'

import {
  RouteConfig,
  DEFAULT_ROUTES as default_routes,
} from '@v2/domains/routing/types/routing.types'

export const loadDataLoaderView = () =>
  import('@v2/domains/data-loader/DataLoader.view')

export const DEFAULT_ROUTES: Record<string, RouteConfig> = {
  [default_routes.NOTIFICATIONS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.NOTIFICATIONS],
    element: createElement(
      lazy(
        () =>
          import('@v2/domains/notification/views/NotificationSettings.view'),
      ),
    ),
  },
  [default_routes.DASHBOARD]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.DASHBOARD],
    element: createElement(
      lazy(() => import('@v2/domains/dashboard/Dashboard')),
    ),
  },
  [default_routes.LEADS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.LEADS],
    element: createElement(
      lazy(() => import('@v2/domains/person/views/leads/LeadsTable.view')),
    ),
  },
  [default_routes.LEAD_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.LEAD_DETAIL],
    element: createElement(
      lazy(
        () => import('@v2/domains/person/views/person-detail/LeadDetail.view'),
      ),
    ),
  },
  [default_routes.LEAD_CREATE]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.LEAD_CREATE],
    element: createElement(
      lazy(() => import('@v2/domains/person/views/leads/CreateLead.view')),
    ),
  },
  [default_routes.ACCOUNTS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ACCOUNTS],
    element: createElement(
      lazy(
        () => import('@v2/domains/person/views/accounts/AccountsTable.view'),
      ),
    ),
  },
  [default_routes.ACCOUNT_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ACCOUNT_DETAIL],
    element: createElement(
      lazy(
        () =>
          import('@v2/domains/person/views/person-detail/AccountDetail.view'),
      ),
    ),
  },
  [default_routes.MERGING_TOOL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.MERGING_TOOL],
    element: createElement(
      lazy(
        () => import('@v2/domains/merging-tool/views/PersonMergingTool.view'),
      ),
    ),
  },
  [default_routes.TICKETS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.TICKETS],
    element: createElement(
      lazy(() => import('@v2/domains/ticket/views/Tickets.view')),
    ),
  },
  [default_routes.TASKS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.TASKS],
    element: createElement(
      lazy(() => import('@v2/domains/task/views/TasksTable.view')),
    ),
  },
  [default_routes.ESCALATIONS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ESCALATIONS],
    element: createElement(
      lazy(() => import('@v2/domains/escalation/views/EscalationTable.view')),
    ),
  },
  [default_routes.WEB_SITES]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.WEB_SITES],
    element: createElement(
      lazy(() => import('@v2/domains/web-sites/views/WebSitesTable.view')),
    ),
  },
  [default_routes.ADMINISTRATION]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION],
    element: createElement(
      lazy(
        () => import('@v2/domains/administration/views/Administration.view'),
      ),
    ),
  },
  [default_routes.ADMINISTRATION_ABCS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_ABCS],
    element: createElement(
      lazy(
        () =>
          import('@v2/domains/administration/views/ABCsAdministration.view'),
      ),
    ),
  },
  [default_routes.ADMINISTRATION_POLICIES]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_POLICIES],
    element: createElement(
      lazy(() => import('@v2/domains/policy/views/Policies.view')),
    ),
  },
  [default_routes.ADMINISTRATION_ROLES]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_ROLES],
    element: createElement(
      lazy(() => import('@v2/domains/role/views/Roles.view')),
    ),
  },
  [default_routes.ADMINISTRATION_ROLES_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_ROLES_DETAIL],
    element: createElement(
      lazy(() => import('@v2/domains/role/views/Role.view')),
    ),
  },
  [default_routes.ADMINISTRATION_TAGS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_TAGS],
    element: createElement(
      lazy(() => import('@v2/domains/tag/views/Tags.view')),
    ),
  },
  [default_routes.ADMINISTRATION_USERS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_USERS],
    element: createElement(
      lazy(() => import('@v2/domains/user/views/Users.view')),
    ),
  },
  [default_routes.ADMINISTRATION_USERS_CREATE]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_USERS_CREATE],
    element: createElement(
      lazy(() => import('@v2/domains/user/views/CreateUser.view')),
    ),
  },
  [default_routes.ADMINISTRATION_USERS_DETAILS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_USERS_DETAILS],
    element: createElement(
      lazy(() => import('@v2/domains/user/views/SingleUser.view')),
    ),
  },
  [default_routes.ADMINISTRATION_EMAIL_TEMPLATE]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_EMAIL_TEMPLATE],
    element: createElement(
      lazy(
        () =>
          import(
            '@v2/domains/email-template/views/EmailTemplates/EmailTemplates.view'
          ),
      ),
    ),
  },
  [default_routes.ADMINISTRATION_EMAIL_TEMPLATE_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[
      default_routes.ADMINISTRATION_EMAIL_TEMPLATE_DETAIL
    ],
    element: createElement(
      lazy(
        () =>
          import(
            '@v2/domains/email-template/views/EmailTemplate/EmailTemplate.view'
          ),
      ),
    ),
  },
  [default_routes.ADMINISTRATION_EMAIL_TEMPLATE_CREATE]: {
    ...DEFAULT_ROUTES_CONFIG[
      default_routes.ADMINISTRATION_EMAIL_TEMPLATE_CREATE
    ],
    element: createElement(
      lazy(
        () =>
          import(
            '@v2/domains/email-template/views/CreateEmailTemplate/CreateEmailTemplate.view'
          ),
      ),
    ),
  },
  [default_routes.ADMINISTRATION_FORM_BUILDER]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ADMINISTRATION_FORM_BUILDER],
    element: createElement(
      lazy(() => import('@v2/domains/form-builder/views/FormBuilder.view')),
    ),
  },
  [default_routes.REPORTS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.REPORTS],
    element: createElement(
      lazy(() => import('@v2/domains/report/views/Reports')),
    ),
  },
  [default_routes.DATA_PROCESSING]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.DATA_PROCESSING],
    element: createElement(
      lazy(() => import('@v2/domains/data-process/view/DataProcess')),
    ),
  },
  [default_routes.SEARCH]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.SEARCH],
    element: createElement(
      lazy(() => import('@v2/domains/person/views/search/SearchResult.view')),
    ),
  },
  [default_routes.SMS_CAMPAIGNS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.SMS_CAMPAIGNS],
    element: createElement(
      lazy(() => import('src/default/pages/Sms/SmsCampaigns')),
    ),
  },
  [default_routes.SMS_CAMPAIGNS_CREATE]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.SMS_CAMPAIGNS_CREATE],
    element: createElement(
      lazy(
        () =>
          import(
            '@v2/domains/smsCampaigns/views/CreateSmsCampaignView/CreateSmsCampaignView'
          ),
      ),
    ),
  },
  [default_routes.SMS_CAMPAIGNS_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.SMS_CAMPAIGNS_DETAIL],
    element: createElement(
      lazy(() => import('src/default/pages/Sms/SmsCampaignDetail')),
    ),
  },
  [default_routes.COMMUNICATIONS_HUB_SMS_CAMPAIGN_CREATE]: {
    ...DEFAULT_ROUTES_CONFIG[
      default_routes.COMMUNICATIONS_HUB_SMS_CAMPAIGN_CREATE
    ],
    element: createElement(
      lazy(
        () =>
          import(
            '@v2/domains/sms-campaigns/views/CreateSmsCampaignWizard.view'
          ),
      ),
    ),
  },
  [default_routes.COMMUNICATIONS_HUB_SMS_CAMPAIGN_EDIT]: {
    ...DEFAULT_ROUTES_CONFIG[
      default_routes.COMMUNICATIONS_HUB_SMS_CAMPAIGN_EDIT
    ],
    element: createElement(
      lazy(
        () =>
          import(
            '@v2/domains/sms-campaigns/views/CreateSmsCampaignWizard.view'
          ),
      ),
    ),
  },
  [default_routes.COMMUNICATIONS_HUB_SMS_CAMPAIGN_TODO]: {
    ...DEFAULT_ROUTES_CONFIG[
      default_routes.COMMUNICATIONS_HUB_SMS_CAMPAIGN_TODO
    ],
    element: createElement(
      lazy(
        () =>
          import('@v2/domains/sms-campaigns/views/SmsCampaignsDummyView.view'),
      ),
    ),
  },
  [default_routes.COMMUNICATIONS_HUB]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.COMMUNICATIONS_HUB],
    element: createElement(
      lazy(
        () =>
          import('@v2/domains/communications-hub/views/CommunicationsHub.view'),
      ),
    ),
  },
  [default_routes.COMMUNICATIONS_HUB_SMS_CAMPAIGN]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.COMMUNICATIONS_HUB_SMS_CAMPAIGN],
    element: createElement(
      lazy(
        () => import('@v2/domains/sms-campaigns/views/SmsCampaignsView.view'),
      ),
    ),
  },
  [default_routes.COMMUNICATIONS_HUB_SMS_CAMPAIGN_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[
      default_routes.COMMUNICATIONS_HUB_SMS_CAMPAIGN_DETAIL
    ],
    element: createElement(
      lazy(
        () => import('@v2/domains/sms-campaigns/views/SmsCampaignDetail.view'),
      ),
    ),
  },
  [default_routes.FORM_SUBMISSIONS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.FORM_SUBMISSIONS],
    element: createElement(
      lazy(() => import('@v2/domains/forms/views/FormSubmissions.view')),
    ),
  },
  [default_routes.FORM_SUBMISSIONS_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.FORM_SUBMISSIONS_DETAIL],
    element: createElement(
      lazy(() => import('@v2/domains/forms/views/FormSubmissionDetail.view')),
    ),
  },
  [default_routes.UPLOAD_FILE]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.UPLOAD_FILE],
    element: createElement(lazy(loadDataLoaderView)),
  },
  [default_routes.TEAM_LEAD_HUB]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.TEAM_LEAD_HUB],
    element: createElement(
      lazy(() => import('@v2/domains/team-lead-hub/views/TeamHubLead.view')),
    ),
  },
  [default_routes.CLINICS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.CLINICS],
    element: createElement(
      lazy(() => import('@v2/domains/clinics/views/Clinics.view')),
    ),
  },
  [default_routes.CLINIC_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.CLINIC_DETAIL],
    element: createElement(
      lazy(() => import('@v2/domains/clinics/views/SingleClinic.view')),
    ),
  },
  [default_routes.LOCATIONS]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.LOCATIONS],
    element: createElement(
      lazy(() => import('@v2/domains/location/views/Locations.view')),
    ),
  },
  [default_routes.ENROLLMENT_CHECKER]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.ENROLLMENT_CHECKER],
    element: createElement(
      lazy(() => import('@v2/domains/enrollment/EnrollmentChecker.view')),
    ),
  },
  [default_routes.RECENT_VIEWED]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.RECENT_VIEWED],
    element: createElement(
      lazy(() => import('@v2/domains/recentViewed/RecentViewed.view')),
    ),
  },
  [default_routes.LIST_BUILDER]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.LIST_BUILDER],
    element: createElement(
      lazy(() => import('@v2/domains/list-builder/views/Lists.view')),
    ),
  },
  [default_routes.LIST_BUILDER_CREATE]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.LIST_BUILDER_CREATE],
    element: createElement(
      lazy(
        () => import('@v2/domains/list-builder/views/CreateListWizard.view'),
      ),
    ),
  },
  [default_routes.LIST_BUILDER_DETAIL]: {
    ...DEFAULT_ROUTES_CONFIG[default_routes.LIST_BUILDER_DETAIL],
    element: createElement(
      lazy(() => import('@v2/domains/list-builder/views/ListDetails.view')),
    ),
  },
}
